import { render, staticRenderFns } from "./AlternativeTextField2.vue?vue&type=template&id=676651d2&"
import script from "./AlternativeTextField2.vue?vue&type=script&lang=js&"
export * from "./AlternativeTextField2.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeTextField2.vue?vue&type=style&index=0&id=676651d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports